<template>
  <body>
    <div class="container">
        <h1 class="title pb-3 mb-3">Verify your account</h1>
        <p class="text pb-4 mb-5">In order to download your digital Rewards card, please verify your account.</p>
        <p class="text mb-5">We’ve sent an email to <span class="email-font-weight">{{ email }}</span>. Please check your inbox for the verification link. If you no longer have access to this email address, please call our Customer Service team on <span class="hyperlink">+44 (0)20 7730 1234</span></p>
        <p class="text">Once you have verified your account <router-link to="/en-gb/sign-in"><span class="hyperlink">sign in to access your Rewards account</span></router-link></p>
    </div>
  </body>
</template>

<script>
export default {
  name: 'VerifyAccount',
  components: {
  },
  data () {
    return {
    }
  },
  props:['email'],
  created() {
    if(this.$props == null || this.email == null || this.email == ''){
      this.$router.push({ path:'/en-gb' });
    }
  }
}

</script>

<style lang="scss" scoped>

</style>
